module.exports = __webpack_public_path__ + "img/video-cover.f8a6732d.png";